export default __webpack_public_path__ + "static/media/slider-img12.7ad45c5b.jpg";